export default {
  title: 'Driv din virksomhed hvor som helst',
  description: 'Log ind på din eksisterende konto.',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'Indtast e-mail',
    },
    password: {
      label: 'Adgangskode',
      placeholder: 'Indtast adgangskode',
    },
    error_messages: {
      missing_info: 'Manglende oplysninger',
      wrong_credentials: 'Forkert e-mail eller adgangskode',
    },
  },
  buttons: {
    login: 'Log ind',
    forgot_password: 'Glemt adgangskode',
  },
  white_label: {
    title: 'Log ind på dit dashboard',
    form: {
      email: {
        label: 'E-mailadresse',
        placeholder: 'du@restaurant.com',
      },
      password: {
        label: 'Adgangskode',
        placeholder: 'Indtast din adgangskode',
      },
    },
    buttons: {
      login: 'Log ind',
    },
    intro: {
      eyebrow: 'Ordrehåndtering',
      headline: 'Driv din restaurant hvor som helst.',
      description: 'Ordrer, menuer, åbningstider og udbetalinger — alt samlet ét sted.',
      features: {
        live: {
          title: 'Live',
          subtitle: 'ordresporing',
        },
        instant: {
          title: 'Øjeblikkelige',
          subtitle: 'menuændringer',
        },
        any_device: {
          title: 'Enhver enhed',
          subtitle: 'telefon eller tablet',
        },
      },
    },
  },
};
